export const getModalTitle = (steps: number[], step: number) => {
  const currentStep = steps.indexOf(step) + 1;

  return `Step ${currentStep} of ${steps.length}`;
};
